import { ClientContext } from '@ms/yammer-data/dist/telemetry';

import { getUserAgentDetails } from '../userAgent';

export type GetClientContext = (hostClientType?: string, hostAppName?: string) => ClientContext;

const getClientContext: GetClientContext = (hostClientType, hostAppName) => {
  const { osName, deviceType } = getUserAgentDetails();

  return {
    osName,
    deviceType,
    hostClientType,
    hostAppName,
  };
};

export default getClientContext;
